import { createSlice } from '@reduxjs/toolkit';

export const careplanInitialState: any = {
  careplanConfig: {} as any,
  listData: {} as any,
  careplanData: {} as any,
  conditionsList: [],
  careTeamList: [],
  patientUsersList: [],
  encounterList: [],
  orgList: [],
  deviceList: [],
  practitionerList: [],
  practitionerRoleList: [],
  medicationsList: [],
  surveyList: [],
  caregiverList: [],
  notesData: {} as any,
  activityData: {} as any,
};

export const carePlanReducer = createSlice({
  name: 'carePlanData',
  initialState:careplanInitialState,
  reducers: {
    setCareplanConfig: (state, action) => {
      state.careplanConfig = action.payload;
    },
    setCareplanData: (state, action) => {
      state.careplanData = action.payload;
    },
    setConditionsList: (state, action) => {
      state.conditionsList = action.payload;
    },
    setCareTeamsList: (state, action) => {
      state.careTeamList = action.payload;
    },
    setPatientUserList: (state, action) => {
      state.patientUsersList = action.payload;
    },
    setEncounterList: (state, action) => {
      state.encounterList = action.payload;
    },
    setOrgList: (state, action) => {
      state.orgList = action.payload;
    },
    setDeviceList: (state, action) => {
      state.deviceList = action.payload;
    },
    setPractitionerList: (state, action) => {
      state.practitionerList = action.payload;
    },
    setPractitionerRoleList: (state, action) => {
      state.practitionerRoleList = action.payload;
    },
    setMedicationsList: (state, action) => {
      state.medicationsList = action.payload;
    },
    setNotesData: (state, action) => {
      state.notesData = action.payload;
    },
    setActivityData: (state, action) => {
      state.activityData = action.payload;
    },
    setSurveyList: (state, action) => {
      state.surveyList = action.payload;
    },
    setCaregiverList: (state, action) => {
      state.caregiverList = action.payload;
    },
    setListData: (state, action) => {
      const updateObject = action.payload;
      Object.keys(updateObject).forEach((key) => {
        state.listData[key] = updateObject[key];
      });
    },
    resetCarePlanReducer: () => careplanInitialState
  }
});

export const {
  setConditionsList,
  setCareTeamsList,
  setOrgList,
  setPatientUserList,
  setCareplanData,
  resetCarePlanReducer,
  setEncounterList,
  setDeviceList,
  setPractitionerList,
  setPractitionerRoleList,
  setNotesData,
  setSurveyList,
  setMedicationsList,
  setCaregiverList,
  setActivityData,
  setCareplanConfig,
  setListData
} = carePlanReducer.actions;

export default carePlanReducer.reducer;
